import React from 'react';

import { IconPrinter, IconUserPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Plan } from '@cfa/pathway-fe-shared/xp';

import { itemByLanguage } from '@/utils/language';

import { printPlan } from '@/components/print-report';
import { PrintReportButton } from '@/components/PrintReportButton';

import PopoverMenuButton from 'components/PopoverMenuButton/PopoverMenuButton';
import PopoverMenuButtonItem from 'components/PopoverMenuButton/PopoverMenuButtonItem';

interface ButtonsProps {
  plan: Plan;
  onShowEnableCompliancePlan: (id: string, name: string) => void;
}

const Buttons: React.FC<ButtonsProps> = ({
  plan,
  onShowEnableCompliancePlan,
}) => {
  const { t } = useTranslation();

  const isEnabled = plan.status === 'ACTIVE';

  const handlePrintReport = () => {
    printPlan(plan);
  };

  if (isEnabled) {
    return (
      <PrintReportButton
        className="m-2.5!"
        data-testid="PrintReport"
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          handlePrintReport();
        }}
      />
    );
  }

  return (
    <PopoverMenuButton data-testid="PlanCardMenu">
      <PopoverMenuButtonItem
        dataTestId="EnablePlan"
        icon={<IconUserPlus />}
        isVisible={!isEnabled}
        onClick={() => {
          onShowEnableCompliancePlan(plan.id, itemByLanguage(plan.name, ''));
        }}
        text={t('Button.enablePlan')}
      />
      <PopoverMenuButtonItem
        dataTestId="PrintReport"
        icon={<IconPrinter />}
        onClick={handlePrintReport}
        text={t('Button.printReport')}
      />
    </PopoverMenuButton>
  );
};

export default Buttons;
